import { render, staticRenderFns } from "./schemeDetail.vue?vue&type=template&id=ff5aa522&scoped=true"
import script from "./schemeDetail.vue?vue&type=script&lang=js"
export * from "./schemeDetail.vue?vue&type=script&lang=js"
import style0 from "./schemeDetail.vue?vue&type=style&index=0&id=ff5aa522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5aa522",
  null
  
)

export default component.exports